import request from '../helpers/request';

const deleteWarrantyDocs = async (docId) => {
  return await request.delete(
    `/Warranty/docs/${docId}`,
    {},
    'Не удалось удалить документ'
  );
};

export default deleteWarrantyDocs;
